import { SET_CUSTOMER_DATA, CLEAR_CUSTOMER_DATA } from "../actions/types";

const initialState = {
	first_name: "",
	last_name: "",
	email: "",
	phone: "",
	beta_feature_user: false,
};

export const customerData = function (state = initialState, action: any) {
	const { type, payload } = action;

	switch (type) {
		case SET_CUSTOMER_DATA:
			return payload;
		case CLEAR_CUSTOMER_DATA:
			return state;

		default:
			return state;
	}
};
